"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _RadioButton = _interopRequireDefault(require("../RadioButton"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _RadioGroup = _interopRequireDefault(require("./RadioGroup.proptypes"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "RadioGroup__Wrapper",
  componentId: "sc-uvztcl-0"
})(["padding:", ";display:flex;flex-direction:", ";> div{padding:", ";margin-top:", ";margin-left:", ";margin:", ";}div > p{font-size:", ";}& #radioBedOption{margin-left:0px;padding-top:0px;color:", ";margin-right:", ";}"], function (_ref) {
  var theme = _ref.theme,
    isMobile = _ref.isMobile;
  return isMobile && "".concat(theme.space.tiny, " ").concat(theme.space.none);
}, function (_ref2) {
  var vertical = _ref2.vertical;
  return vertical ? 'column' : 'row';
}, function (_ref3) {
  var theme = _ref3.theme,
    customProperties = _ref3.customProperties;
  return customProperties && customProperties !== null && customProperties !== void 0 && customProperties.paddingTopBottom ? "".concat(theme.space[customProperties.paddingTopBottom], " ").concat(theme.space.none) : "".concat(theme.space.tiny, " ").concat(theme.space.none);
}, function (_ref4) {
  var theme = _ref4.theme,
    customProperties = _ref4.customProperties;
  return customProperties && customProperties !== null && customProperties !== void 0 && customProperties.marginTop ? theme.space[customProperties.marginTop] : theme.space.tiny;
}, function (_ref5) {
  var theme = _ref5.theme,
    vertical = _ref5.vertical;
  return !vertical ? theme.space.tiny : theme.space.none;
}, function (_ref6) {
  var theme = _ref6.theme,
    isMobile = _ref6.isMobile,
    customProperties = _ref6.customProperties;
  return customProperties && customProperties !== null && customProperties !== void 0 && customProperties.mobileTopBottomMargin ? isMobile && "".concat(theme.space[customProperties.mobileTopBottomMargin], " ").concat(theme.space.small) : isMobile && "".concat(theme.space.tiny, " ").concat(theme.space.small);
}, function (_ref7) {
  var isMobile = _ref7.isMobile;
  return isMobile ? '1rem' : '0.875rem';
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.greyDark;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.space.tiny;
});
var RadioGroup = function RadioGroup(_ref10) {
  var theme = _ref10.theme,
    value = _ref10.value,
    _onChange = _ref10.onChange,
    vertical = _ref10.vertical,
    options = _ref10.options,
    customProperties = _ref10.customProperties,
    color = _ref10.color,
    isReversed = _ref10.isReversed,
    isFullWidth = _ref10.isFullWidth,
    accessible = _ref10.accessible,
    isMobile = _ref10.isMobile,
    textColor = _ref10.textColor;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var getMain = function getMain(optionsArr) {
    return /*#__PURE__*/_react.default.createElement(Wrapper, {
      customProperties: customProperties,
      vertical: vertical,
      isMobile: isMobile,
      className: "radio-group",
      theme: themeContext
    }, optionsArr.map(function (item) {
      return /*#__PURE__*/_react.default.createElement(_RadioButton.default, {
        id: item.value,
        vertical: vertical,
        selected: value === item.value,
        text: item.label,
        isReversed: isReversed,
        isFullWidth: isFullWidth,
        onChange: function onChange() {
          _onChange(item);
        },
        color: color,
        customProperties: customProperties,
        accessible: accessible,
        textColor: textColor
      });
    }));
  };
  return themeContext ? getMain(options) : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain(options));
};
RadioGroup.propTypes = _RadioGroup.default.PropTypes;
RadioGroup.defaultProps = _RadioGroup.default.DefaultProps;
var _default = RadioGroup;
exports.default = _default;